import React, { Dispatch, ReactNode, createContext, useReducer } from 'react';

import * as types from './types';
import { SubscriptionState } from '../../types';

type SubscriptionAction = { type: string; payload?: SubscriptionState };

const initialState: SubscriptionState | null = null;

const subscriptionReducer = (
  state: SubscriptionState | null,
  action: SubscriptionAction,
): SubscriptionState | null => {
  switch (action.type) {
    case types.SET_USER_SUBSCRIPTIONS:
      if (action.payload) {
        return {
          ...state,
          ...action.payload,
        };
      }
      return initialState;
    case types.RESET_USER_SUBSCRIPTIONS:
      return initialState;
    default:
      return initialState;
  }
};

type SubscriptionContextType = [
  SubscriptionState | null,
  Dispatch<SubscriptionAction>,
];
export const SubscriptionContext = createContext<SubscriptionContextType>([
  initialState,
  () => initialState,
]);

const SubscriptionProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [subscriptionInfo, dispatchSubscriptonInfo] = useReducer(
    subscriptionReducer,
    initialState,
  );

  return (
    <SubscriptionContext.Provider
      value={[subscriptionInfo, dispatchSubscriptonInfo]}
    >
      {children}
    </SubscriptionContext.Provider>
  );
};

export default SubscriptionProvider;
